$(document).ready(function () {
    loopThroughCartItemsToAddFreeItems();
    $('.empty-cart-section').hide();
    console.log("check");
  });
  /* discount working */
  function loopThroughCartItemsToAddFreeItems() {
    console.log("check2");
    console.log(discountArray);
    // check if the Local exists
    let checkLocalForDiscount = localStorage.getItem("cartDiscount");
    console.log(checkLocalForDiscount);
    // if yes, then loop through the discounted products list to see if the item exists in the cart or not
    if (checkLocalForDiscount == "true") {
        console.log("check3");
      let productRequired;
      let productAddedFree;
      /* Check if there is localStrage for the mapping */
      if (localStorage.LocalVisitedURLDiscountArray == undefined) {
        console.log("local storage undefined");
        visitedURLDiscountArray = {};
      } else {
        console.log("check4");
        /* If YES, then pass the value to a variable */
        console.log("local storage NOT undefined");
        visitedURLDiscountArray = JSON.parse(
          localStorage.LocalVisitedURLDiscountArray
        );
        console.log("check5");
        console.log(visitedURLDiscountArray);
      }
      //loop through the discounted products list
      console.log("check6");
      console.log("discountArray: " + discountArray);
      $.each(discountArray, function (key, value) {
          console.log("value: " + value);
        if (value != "") {
          value = value.split("~");
          productRequired = value[0];
          productAddedFree = value[1];
          let url = value[2];
          console.log("productRequired: " + productRequired);
          console.log("productAddedFree: " + productAddedFree);
          console.log("check URL in LOCAL STORAGE: " + url);
          if (url in visitedURLDiscountArray) {
            // loop through the items in cart
            $(CartJS.cart.items).each(function () {
              let checkFreeItemInCart = false;
              // check if the item is in the cart
              if (this.id == productRequired) {
                console.log("Required item is in the cart: " + this.id);
                // if the item is in the cart, then add the free item
                //check if the free item is in the cart
                $(CartJS.cart.items).each(function () {
                  if (productAddedFree == this.id) {
                    console.log("FREE item in cart" + productAddedFree);
                    //FREE ITEM IS THE CART
                    // do nothing
                    checkFreeItemInCart = true;
                  }
                });
                // for the current arrayItem, if the free product isn't added to the cart, then add it
                if (checkFreeItemInCart == false) {
                  CartJS.addItem(
                    productAddedFree,
                    1,
                    {},
                    {
                      success: function (response, textStatus, jqXHR) {
                        console.log(CartJS.cart);
                        location.reload();
                      },
                      error: function (jqXHR, textStatus, errorThrown) {
                        console.log("Something went wrong");
                      },
                    }
                  );
                  console.log("----------------------");
                }
              } else {
                console.log("URL item is not in the cart");
              }
            });
          }
        }
      });
    }
  }

  /* Function to remove the free item from the cart if the primary item is removed */
  /*Also check that the free item quantity = 1 then remove it completely, else update the quantity to 1 */
  /* Remove the primary item */
  $( ".remove" ).click(function() {
      let variantID = parseInt($(this).attr('data-id'));
    console.log("variantID: " + variantID);
    console.log("removeitem");
    CartJS.removeItemById(variantID, {
      "success": function (data, textStatus, jqXHR) {
        console.log('Removed!');
        console.log(data.item_count);
        console.log(data);
        console.log(variantID);
        /* remove the line items from the cart page */
        $('.cart-table-body').filter('[data-variant-id="' + variantID + '"]').remove();
        // $('.cart-table-body[data-variant-id="variantID"]').remove();
        /*Also check that the free item quantity = 1 then remove it completely, else update the quantity to 1 */
        $.each(discountArray, function (key, value) {
            
                value = value.split("~");
                productRequired = parseInt(value[0]);
                productAddedFree = parseInt(value[1]);
                
               
                console.log("productRequired: " + productRequired);
                console.log("productAddedFree: " + productAddedFree);
                console.log("variantID: " + variantID);
                
                //loop through items in cart
                $(data.items).each(function () {
                    if(this.id == productAddedFree)
                    {
                        //free product is in the cart
                        let quantity = this.quantity;
                        if(quantity == 1)
                        {
                            removeFreeItem(variantID, productRequired, productAddedFree)
                        }
                        else{
                            //update the item
                            updateFreeItemQuantity(productAddedFree, quantity);
                        }
                    }

                });
                
            
           
        });

        //update the line_price and total
        bindInformation(data, variantID);
      },
      "error": function (jqXHR, textStatus, errorThrown) {
        console.log('Error: ' + errorThrown + '!');
      }
    });
  });


  function bindInformation(data, variantID) {
    var cartTotal = data.total_price;
    cartTotal = cartTotal / 100;
    cartTotal = formatter.format(cartTotal)
    console.log("cartTotal: " + cartTotal);
    $('.js-cart-total').html(cartTotal);
    let returnDataForBind = data;
    console.log("Bind Line Item Price");
    console.log(returnDataForBind);
    console.log(variantID);
    $(returnDataForBind.items).each(function () {
      console.log(this.id);
      if (this.id == variantID) {
        console.log("variantID matched");
        let linePrice = this.line_price;
        linePrice = linePrice / 100;
        linePrice = formatter.format(linePrice)
        console.log(linePrice)
        $('.js-line-item-price').filter('[data-variant-id="' + variantID + '"]').text(linePrice);
      }
    });
    if (returnDataForBind.item_count == 0) {
      $('.empty-cart-section').show();
      $('.js-show-cart-items-section').hide();
      $('#shopify-section-cart-recommendations').hide();
    }
    //reloadAjaxCartItems(data);

  }


  function removeFreeItem(variantID, productRequired, productAddedFree)
  {

    if(variantID == productRequired)
    {
      
      // remove the free rpoduct too
      CartJS.removeItemById(productAddedFree, {
          "success": function (data, textStatus, jqXHR) {
              console.log('Removed! FREE');
              $('.cart-table-body').filter('[data-variant-id="' + productAddedFree + '"]').remove();
              bindInformation(data, variantID);
          },
          "error": function (jqXHR, textStatus, errorThrown) {
            console.log('Error: ' + errorThrown + '!');
          }
      });
    }
  }

  function updateFreeItemQuantity(productAddedFree, quantity)
  {
    quantity = quantity-1;
    CartJS.updateItemById(productAddedFree, quantity, {}, {
        "success": function (data, textStatus, jqXHR) {
          console.log('quantity updated!');
          console.log(data.item_count);
          console.log(data);
          $('.cart-table-body').find('.quantity input').filter('[data-id="' + productAddedFree + '"]').val(quantity);

          //update the line_price and total
          bindInformation(data, productAddedFree);
        },
        "error": function (jqXHR, textStatus, errorThrown) {
          console.log('Error: ' + errorThrown + '!');
        }
      });
  }

const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  })
